/*eslint-disable*/ import React from "react";

import makeStyles from '@mui/styles/makeStyles';
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
//const Footer = dynamic(()=>import("components/Footer/TribalismFooter.js"))

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Section4Clients from "pages-sections/home-page/Section4ClientsLandingPage.js";

import Section7Testimonials from "pages-sections/home-page/Section7Testimonials.js";

import SectionProjects from "pages-sections/sections-page/SectionProjects2small.js";

import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";

import blogPostPageStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostPageStyle.js";

const useStyles = makeStyles(blogPostPageStyle);

export default function BlogPostPage() {

  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Our Work - Tribalism"
        image="/img/sections/services/all-services/7.webp"
        url="https://www.tribalism.com.au/our-work"
        type="article"
        description="We are a Data & Analytics Agency based in Melbourne, Australia. We cover analytics, search engine marketing and web design. We help your digital platforms perfrorm better!"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/sections/services/all-services/7.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Case Studies

              </h1>

              <br />

            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      
      <div className={classes.main}> 
        <SectionProjects id="case-studies" />
        <Section4Clients id="clients" /> 
        <Section7Testimonials id="testimonials" /> 
        <Section8Contacts id="contact" /> 
      
      </div>

      <Footer/> 
    </div>
  );
}
